module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-682cc6f7c5e589f367bd2fd36db2d3d7.png";